import type { RouterOutputs } from '../../lib/trpc.js'
import type { Job } from '../job-card/types.js'
import { DEFAULT_RULE, type RuleDraft } from './rule.js'

export type RepeatForJob = RouterOutputs['repeat']['forJob']
export type ScheduleView = NonNullable<RepeatForJob['schedule']>

/**
 * A new rule for this job: its services at the price it was sold for, its
 * kind of work and its length, repeating as often as the imported ServiceM8
 * series did when there was one — else every six months, the commonest.
 */
export function draftFromJob(job: Job, imported: RepeatForJob['imported']): RuleDraft {
  return {
    ...DEFAULT_RULE,
    ...(imported?.interval ?? {}),
    categoryId: job.category?.id ?? null,
    estimatedMinutes: job.estimatedMinutes ?? null,
    services: job.services.map((service) => ({
      serviceTypeId: service.serviceType.id,
      name: service.serviceType.name,
      priceIncTax: service.priceIncTax ?? null,
    })),
  }
}

export function draftFromSchedule(schedule: ScheduleView): RuleDraft {
  return {
    intervalCount: schedule.intervalCount,
    intervalUnit: schedule.intervalUnit,
    anchor: schedule.anchor,
    bookWith: schedule.bookWith,
    bookWithUserId: schedule.bookWithUserId,
    ends: schedule.ends,
    endAfterVisits: schedule.endAfterVisits,
    endsOn: schedule.endsOn,
    categoryId: schedule.categoryId,
    estimatedMinutes: schedule.estimatedMinutes,
    standingNotes: schedule.standingNotes ?? '',
    services: schedule.services.map((service) => ({
      serviceTypeId: service.serviceTypeId,
      name: service.name,
      priceIncTax: service.priceIncTax,
    })),
  }
}
